import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import BranchComponent from '../components/branch.component';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import { selectBranchesQueryItems } from '../../../../../../redux/branches/selector';
import { branches } from '../../../../../../redux/branches/action';

const ManagementBranch = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const branchQuery = useSelector(selectBranchesQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const organizationUnitsItems = useSelector(selectOrganizationUnitsListItems)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    selectedBranch,
    setSelectedBranch
  ] = useState<any>([])

  const fetchBranchesQueryById= ()=>{
    dispatch(branches.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/branches/query`,entity:'branches',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedBranch({ ...selectedBranch, [field]: event })
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }
    setSelectedBranch({ ...selectedBranch, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  
  useEffect(
    () => {
        dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}
           })).then(()=>{
            if (parmas?.id > 0) {
                fetchBranchesQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
          })
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedBranch(branchQuery?.result?.items)
        setSelectedAddress({ 
            PrimaryAddress: branchQuery?.result?.items?.PrimaryAddress,
            BillingAddress: branchQuery?.result?.items?.BillingAddress,
            ShippingAddress: branchQuery?.result?.items?.ShippingAddress})
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const branchData= {
   
        BranchInfo: {
            Id: selectedBranch?.BranchInfo?.Id || 0,
            Name: selectedBranch?.BranchInfo?.Name,
            PhoneNumber: selectedBranch?.BranchInfo?.PhoneNumber,
            Email: selectedBranch?.BranchInfo?.Email,
            BranchTypeId: selectedBranch?.BranchInfo?.BranchTypeId,
            OrganizationUnitId: selectedBranch?.BranchInfo?.OrganizationUnitId,
            IsPrimaryBranch: selectedBranch?.BranchInfo?.IsPrimaryBranch
          },
        PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: selectedBranch?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: selectedBranch?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress
      }
      if (parmas?.id > 0) {
     dispatch(branches.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/branches`,entity:'branches',jsonData:{
          
    Records: [
        branchData
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(branches.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/branches`,entity:'branches',jsonData:{
            
        Records: [
            branchData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/organization/organization-management/branches')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <BranchComponent 
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          branchTypes={librariesItems?.BranchType}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onInnerFormChange={handleInnerFormChange}
          organizationUnits={organizationUnitsItems?.result?.items}
          selectedAddress={selectedAddress}
          selectedBranch={selectedBranch}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementBranch;